import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';
import { generateIcon as icon } from 'components/_particles/icon/icon';
import Swipe from 'javascripts/utils/Swipe';

export default class TimelineSlider {
  constructor($timeline, mq) {
    this.$timeline = $timeline;
    this.$inner = this.$timeline.querySelector('.phase-timeline__inner');
    this.$itemsContainer = this.$timeline.querySelector('.phase-timeline__items');
    this.$itemWrappers = this.$timeline.querySelectorAll('.phase-timeline__item');

    this.isDesktop = mq.matches;
    this.length = this.$itemWrappers.length;

    if (this.length > 0) {
      this.activeIndex = 0;
      this.indexOfActiveItem = 0;
      this.maxIndex = this.getMaxIndex();

      this.slideWidth = this.getActiveSlideWidth();
      this.initSwiping();

      window.addEventListener('resize', this.handleResize);

      this.$itemWrappers.forEach(($el, index) => {
        if ($el.classList.contains('phase-timeline__item--active')) {
          this.indexOfActiveItem = index;
        }
      });

      if (this.indexOfActiveItem < this.maxIndex) {
        this.activeIndex = this.indexOfActiveItem;
      }

      this.updateItemPosition();
      this.updateArrows();
    }
  }

  initSwiping = () => {
    this.swipe = new Swipe(this.$itemsContainer);
    this.swipe.onLeft(this.handleOnLeftSwipe);
    this.swipe.onRight(this.handleOnRightSwipe);
  }

  deinitSwiping = () => {
    if (this.swipe && this.swipe.deconstructor) {
      this.swipe.deconstructor();
    }
  }

  handleOnLeftSwipe = () => {
    this.nextItem();
  }

  handleOnRightSwipe = () => {
    this.prevItem();
  }

  getMaxIndex = () => {
    let maxIndex = 0;

    if (this.isDesktop) {
      maxIndex = this.length - 4;
    } else if (window.matchMedia('(min-width: 830px)').matches) {
      maxIndex = this.length - 3;
    } else if (window.matchMedia('(min-width: 580px)').matches) {
      maxIndex = this.length - 2;
    } else {
      maxIndex = this.length - 1;
    }

    return maxIndex;
  };

  getActiveSlideWidth = () => this.$itemWrappers[this.activeIndex].offsetWidth;

  handleResize = () => {
    this.activeIndex = 0;
    if (this.indexOfActiveItem <= this.maxIndex && !this.isDesktop) {
      this.activeIndex = this.indexOfActiveItem;
    }
    this.maxIndex = this.getMaxIndex();
    this.slideWidth = this.getActiveSlideWidth();
    this.updateItemPosition();
    this.updateArrows();
  };

  prevItem = () => {
    if (this.activeIndex > 0) {
      this.activeIndex -= 1;
      this.updateItemPosition();
      this.updateArrows();
    }
  };

  nextItem = () => {
    if (this.activeIndex < this.maxIndex) {
      this.activeIndex += 1;
      this.updateItemPosition();
      this.updateArrows();
    }
  };

  updateItemPosition = () => {
    this.$itemsContainer.style.transform = `translateX(${-1 *
      this.activeIndex *
      this.slideWidth}px)`;
  };

  handleLeftArrowClick = () => {
    this.prevItem();
    this.updateArrows();
  }

  handleRightArrowClick = () => {
    this.nextItem();
    this.updateArrows();
  }

  removeArrows = () => {
    const arrowNextNode = this.$timeline.querySelector('.phase-timeline__arrow--next');
    const arrowPrevNode = this.$timeline.querySelector('.phase-timeline__arrow--prev');
    if (arrowNextNode) {
      arrowNextNode.parentElement.removeChild(arrowNextNode);
    }

    if (arrowPrevNode) {
      arrowPrevNode.parentElement.removeChild(arrowPrevNode);
    }
  };

  updateArrows = () => {
    this.removeArrows();

    this.$controlPrev = h(
      'button.phase-timeline__arrow.phase-timeline__arrow--prev',
      {
        onclick: this.handleLeftArrowClick,
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Vorherige Phase'),
        },
      },
      icon({
        icon: 'slider-arrow-left',
        viewBox: '0 0 70 200',
        className: 'phase-timeline__arrow-icon',
      }),
    );

    this.$controlNext = h(
      'button.phase-timeline__arrow.phase-timeline__arrow--next',
      {
        onclick: this.handleRightArrowClick,
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Nächste Phase'),
        },
      },
      icon({
        icon: 'slider-arrow-right',
        viewBox: '0 0 70 200',
        className: 'phase-timeline__arrow-icon',
      }),
    );

    if (this.activeIndex > 0 && !this.$timeline.querySelector('.phase-timeline__arrow--prev')) {
      this.$inner.appendChild(this.$controlPrev);
    }

    if (this.activeIndex < this.maxIndex && !this.$timeline.querySelector('.phase-timeline__arrow--next')) {
      this.$inner.appendChild(this.$controlNext);
    }
  }
}
